export default __webpack_public_path__ + "static/media/NAUHomeAndLife.8634f0d8.svg";